var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPipette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/default/pipette") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/default/pipette",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98246379,8.93821425 L3.72946853,14.1922197 C2.96436604,14.4313225 2.15029678,14.0049155 1.91119395,13.2398131 C1.8377799,13.0048963 1.82554422,12.7559743 1.87448692,12.5163891 L1.91119395,12.3739451 L7.16449226,7.12024272 L8.98246379,8.93821425 Z M6.65891091,5.20186202 L7.36601769,4.49475524 L7.97271531,5.10003865 L10.8005363,2.27241964 C11.5815849,1.49137106 12.8479149,1.49137106 13.6289635,2.27241964 L13.830994,2.47445015 C14.6120426,3.25549874 14.6120426,4.52182869 13.830994,5.30287728 L11.0026679,8.1299912 L11.6086584,8.73739593 L10.9015516,9.44450271 L6.65891091,5.20186202 Z",
    id: "Shape",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipette);
export default __webpack_public_path__ + "static/media/pipette.720e99560373c6ad7df54e8f98b6e6c4.svg";
export { ForwardRef as ReactComponent };